import { BrightnessGenerator } from './BrightnessGenerator';
import { ToneGenerator } from './ToneGenerator';
import { TemperatureGenerator } from './TemperatureGenerator';
import { ZH_TEMPLATES } from '../../constants/templates/zh';
import { EN_TEMPLATES } from '../../constants/templates/en';

export class LabConclusionGenerator {
    constructor(language = 'zh') {
        this.setLanguage(language);
    }

    setLanguage(language) {
        this.language = language;
        const templates = language === 'zh' ? ZH_TEMPLATES : EN_TEMPLATES;

        // 更新所有生成器的语言设置
        this.brightnessGenerator = new BrightnessGenerator(templates);
        this.toneGenerator = new ToneGenerator(templates);
        this.temperatureGenerator = new TemperatureGenerator(templates);
    }

    generateBrightnessConclusion(globalData, partitionsData) {
        return this.brightnessGenerator.generateConclusion(globalData, partitionsData);
    }

    generateToneConclusion(globalData, partitionsData) {
        return this.toneGenerator.generateConclusion(globalData, partitionsData);
    }

    generateTemperatureConclusion(globalData, partitionsData) {
        return this.temperatureGenerator.generateConclusion(globalData, partitionsData);
    }

    generateOverallConclusion(globalData, partitionsData) {

        const brightnessConclusion = this.generateBrightnessConclusion(globalData, partitionsData);
        const toneConclusion = this.generateToneConclusion(globalData, partitionsData);
        const temperatureConclusion = this.generateTemperatureConclusion(globalData, partitionsData);


        return `${brightnessConclusion}\n\n${toneConclusion}\n\n${temperatureConclusion}`;
    }
} 